function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m26.18 13.577-5.788-4.885C19.94 8.312 19.093 8 18.51 8H3.923C2.586 8 1.81 9.048 1.695 9.636c0 0-.287 1.17-.446 1.888C1.09 12.243 1 13.942 1 14.542c0 0 0 2.936.695 3.589s1.693.773 1.693.773c0-1.807 1.551-3.271 3.521-3.271s3.545 1.464 3.545 3.27h7.88c0-1.806 1.385-3.27 3.625-3.27 1.89 0 3.465 1.464 3.465 3.27L27 18.359V15.36c0-.6-.369-1.402-.82-1.783zm-10.588-.995-5.041-.22V9.635h5.04v2.946zm1.592.07V9.636h1.326c.216 0 .704.18.87.32l3.49 2.944-5.686-.248z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.87 16.567c-1.518 0-2.749 1.216-2.749 2.717 0 1.5 1.231 2.716 2.748 2.716 1.518 0 2.748-1.216 2.748-2.716 0-1.5-1.23-2.717-2.748-2.717zm0 4.366a1.66 1.66 0 0 1-1.67-1.65c0-.91.748-1.649 1.67-1.649.921 0 1.668.738 1.668 1.65 0 .91-.747 1.65-1.669 1.65zM6.9 16.567c-1.518 0-2.748 1.216-2.748 2.717 0 1.5 1.23 2.716 2.747 2.716 1.518 0 2.748-1.216 2.748-2.716 0-1.5-1.23-2.717-2.748-2.717zm0 4.366a1.66 1.66 0 0 1-1.67-1.65c0-.91.748-1.649 1.67-1.649.921 0 1.668.738 1.668 1.65a1.66 1.66 0 0 1-1.669 1.65z"
});

var SvgMpv = function SvgMpv(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMpv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mpv.e2270935.svg";
export { ForwardRef as ReactComponent };